import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Popup } from 'components';
import {
  ConnectStep,
  ConfirmStep,
  ResultStep,
  PendingStep,
  NotAllowedStep,
} from '../Steps';

const FavoriteNumberWizardModal = ({
  connectModal,
  confirmModal,
  closeModal,
  successModal,
  openDeleteNumber,
  notAllowedModal,
  changeFreeModal,
  delSuccessModal,
  reConnectModal,
  deleteModal,
  openConfirm,
  errorModal,
  changeModal,
  onChange,
  onDelete,
  onConnect,
  opened,
  step,
  errorType,
}) => (
  <Popup
    opened={opened}
    onClose={closeModal}
  >
    {step === 'connect' && (
      <ConnectStep
        data={connectModal}
        onChange={onChange}
        openConfirm={openConfirm}
      />
    )}
    {step === 'reConnect' && (
      <ConnectStep
        data={reConnectModal}
        onChange={onChange}
        openConfirm={openConfirm}
      />
    )}
    {step === 'change' && (
      <ConnectStep
        data={changeModal}
        onChange={onChange}
        openConfirm={openConfirm}
        openDeleteNumber={openDeleteNumber}
      />
    )}

    {step === 'changeFree' && (
      <ConnectStep
        data={changeFreeModal}
        onChange={onChange}
        openConfirm={openConfirm}
        openDeleteNumber={openDeleteNumber}
      />
    )}

    {step === 'notAllowed' && (
      <NotAllowedStep
        data={notAllowedModal}
        onClose={closeModal}
      />
    )}

    {step === 'confirm' && (
      <ConfirmStep
        data={confirmModal}
        onClose={closeModal}
        onClick={onConnect}
      />
    )}

    {step === 'delete' && (
      <ConfirmStep
        data={deleteModal}
        onClose={closeModal}
        onClick={onDelete}
      />
    )}

    {step === 'pending' && (
      <PendingStep />
    )}

    {step === 'success' && (
      <ResultStep
        data={successModal}
        onClose={closeModal}
      />
    )}

    {step === 'delSuccess' && (
      <ResultStep
        data={delSuccessModal}
        onClose={closeModal}
      />
    )}

    {step === 'error' && (
      <ResultStep
        data={errorModal[errorType]}
        onClose={closeModal}
      />
    )}
  </Popup>
);

FavoriteNumberWizardModal.propTypes = {
  connectModal: PropTypes.object,
  confirmModal: PropTypes.object,
  deleteModal: PropTypes.object,
  successModal: PropTypes.object,
  notAllowedModal: PropTypes.object,
  delSuccessModal: PropTypes.object,
  changeFreeModal: PropTypes.object,
  reConnectModal: PropTypes.object,
  errorModal: PropTypes.object,
  changeModal: PropTypes.object,
  closeModal: PropTypes.func,
  opened: PropTypes.bool,
  step: PropTypes.string,
  openConfirm: PropTypes.func,
  onConnect: PropTypes.func,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  openDeleteNumber: PropTypes.func,
  errorType: PropTypes.string,
};

export default FavoriteNumberWizardModal;
